import { render, staticRenderFns } from "./employee-modal.vue?vue&type=template&id=60669bf6&"
import script from "./employee-modal.vue?vue&type=script&lang=js&"
export * from "./employee-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports